// extracted by mini-css-extract-plugin
export default {"form":"TeamRole_form__G3vPV"};